import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { useWorkspaceStore } from '@/stores/workspace'

/**
 * Whether the selected organization's subscriptions don't allow adding merchants, except for a Super
 * Admin, who may act in any workspace. False until an organization is selected.
 */
export function useMerchantCreationBlocked() {
  const auth = useAuthStore()
  const workspace = useWorkspaceStore()

  return computed(() => {
    const organization = workspace.currentOrganization

    return organization !== null && !organization.canCreateMerchants && !auth.user?.isSystemAdmin
  })
}
